/**
 * Utilities for merging form data and preparing request payloads for beneficial owners.
 */

import moment from 'moment';
import { convertToPhoneRequestFormat, deleteUnwantedRequest } from '../../components/Utils/CommonBaseClass';

/**
 * Merge autosaved data with API-provided beneficial owner data.
 */
export const mergeAutosaveWithApi = (autoSavedData: any[] = [], beneficialOwnerData: any[] = []) => {
  const mergedData: Record<string, any>[] = [];
  const maxLength = Math.max(autoSavedData.length, beneficialOwnerData.length);

  let boSorted = [...beneficialOwnerData]
  boSorted = boSorted.sort((a, b) => a?.id - b?.id);
  
  for (let i = 0; i < maxLength; i++) {
      const bo = boSorted[i];
      let auto:any 
      let autoCheckindex = autoSavedData.findIndex(item => item?.id !== undefined && item.id === bo?.id);
      if(autoCheckindex !== -1){
          auto = autoSavedData[autoCheckindex]
      }else{
          auto = autoSavedData[i];
      }
      if (bo && auto) {
          // Merge auto into bo
          const merged = { ...bo };
          Object.keys(auto).forEach((key) => {
              // if (key === 'id') return; // Preserve ID from bo
              const val = auto[key];
              if (val !== undefined && val !== '') {
              merged[key] = val;
              }
          });
          if(autoCheckindex !== -1){
              mergedData[autoCheckindex] = merged
          }else{
              mergedData.push(merged);
          }
      } else if (bo) {
      mergedData.push(bo); // Only BO exists
      } else if (auto) {
      mergedData.push(auto); // Only auto-saved entry exists
      }
  }

  return mergedData;
};

/**
 * Create a backend-ready request object from form fields.
 */
export const prepareBusinessOwnerRequest = async (data: any) => {
    const req: any = { ...data };
  
    if (!data.id) {
      delete data.id;
      delete req.id;
    }
  
    if (data.dob) {
      req.dob = moment(data.dob).format('MM/DD/YYYY');
    }
  
    const address: any = {
      addressLine1: data.addressLine1,
      addressLine2: data.addressLine2,
      city: data.city,
      state: data.state,
      zip: data.zip,
      isPrimary: true
    };
  
    if (data.address_id) {
      address.id = data.address_id;
    }
  
    req.mailingAddress = [address];
  
    req.businessDetails = {
      ownershipPercentage: data.ownerShipPercentage,
      title: data.jobtitle
    };
  
    req.mobilePhone = convertToPhoneRequestFormat(data.mobilePhone);
    if (req.mobilePhone === '') {
      delete req.mobilePhone;
    }
  
      req.isUSCitizen = data.usCitizen === 'yes';
    req.actAsAuthorizedSignatory = data.authSignatory && data.authSignatory !== 'false' ? true : false;
  
    if (!req.businessDetails.ownershipPercentage) {
      delete req.businessDetails.ownershipPercentage;
    }
  
    const unwantedRequestArray = [
      'state', 'addressLine1', 'city', 'zip', 'addressLine2',
      'jobtitle', 'authSignatory', 'ownerShipPercentage',
      'creditReport', 'usCitizen', 'mobilePhone-select', 'address_id', 'homePhone', 'itin', 'workPhone', 'description'
    ];
  
    deleteUnwantedRequest(req, unwantedRequestArray);
    
    return { data, req };
  };